import script from "./Timer.vue?vue&type=script&setup=true&lang=ts"
export * from "./Timer.vue?vue&type=script&setup=true&lang=ts"

import "./Timer.vue?vue&type=style&index=0&id=2527a434&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2527a434"]])

export default __exports__